export const getDate = (datetime: string): string => {
  return datetime.split(" ")[0];
};

export const getTime = (datetime: string): string => {
  return datetime.split(" ")[1];
};

export const translateDateTime = (
  datetime: string,
  language: string
): string => {
  const date = new Date(datetime);

  // 定义补零函数，使得个位数的月份、日期、小时等显示为两位数
  const padZero = (num: number) => (num < 10 ? `0${num}` : num);

  if (language === "zh") {
    // 格式化为 YYYY年MM月DD日 HH时mm分ss秒
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1); // getMonth() 从0开始，故加1
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());

    return `${year}年${month}月${day}日 ${hours}时${minutes}分${seconds}秒`;
  }

  // 其他语言格式化处理（可以扩展其他语言）
  return datetime;
};

export const formatDateTime = (dateTime: string) => {
  return dateTime.replace("T", " ");
};

export const calculateTimeDifference = (startTime: string, endTime: string) => {
  // 将字符串转换为 Date 对象
  const start = new Date(startTime);
  const end = new Date(endTime);

  // 计算时间差，单位为毫秒
  const diff = end.getTime() - start.getTime();

  // 将时间差转换为分钟和秒
  const minutes = Math.floor(diff / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  // 返回格式化的结果
  return `${minutes}分${seconds}秒`;
};

export const formatToIsoOffset = (date: Date): string => {
  const pad = (n: number, len = 2) => String(n).padStart(len, "0");
  const y = date.getFullYear();
  const M = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  const h = pad(date.getHours());
  const m = pad(date.getMinutes());
  const s = pad(date.getSeconds());
  const SSS = pad(date.getMilliseconds(), 3);

  const offsetMin = -date.getTimezoneOffset(); // 东八区为 +480
  const sign = offsetMin >= 0 ? "+" : "-";
  const abs = Math.abs(offsetMin);
  const oh = pad(Math.floor(abs / 60));
  const om = pad(abs % 60);

  return `${y}-${M}-${d}T${h}:${m}:${s}.${SSS}${sign}${oh}:${om}`;
};
